const common = {
  siteName: "kaiyun.con 官方导航",
  siteDescription: "kaiyun.con 是您寻找开云平台的重要参考入口，提供导航、注册登录指引及常见问题解答",
  nav: {
    home: "首页",
    categories: "分类浏览",
    about: "关于我们",
    articles: "文章指南",
  },
  footer: {
    copyright: "© 2026 kaiyun.con 官方导航入口。本站为开云平台用户提供导航参考服务。",
    quickLinks: "快速链接",
    contactInfo: "联系我们",
    disclaimer: "免责声明：本站为第三方导航信息聚合平台，非开云官方网站。开云相关商标归其各自所有者所有。",
  },
  breadcrumb: {
    home: "首页",
    categories: "分类",
    articles: "文章",
    about: "关于我们",
  },
  home: {
    heroTitle: "kaiyun.con 官方入口 · 快速直达",
    heroSubtitle: "开云平台重要参考导航，汇聚注册登录指引、使用指南及常见问题解答，帮助您快速定位、安全访问。",
    ctaPrimary: "查看导航指引",
    ctaSecondary: "了解更多",
    quickNavTitle: "快捷导航",
    featuredCategories: "热门分类",
    faqTitle: "常见问题解答",
    ctaSectionTitle: "准备好开始了吗？",
    ctaSectionDesc: "立即通过 kaiyun.con 找到开云平台的正确入口，开启您的体验之旅。",
  },
  category: {
    title: "分类浏览",
    allCategories: "全部分类",
    readMore: "阅读更多",
    noArticles: "暂无相关文章",
  },
  article: {
    backToList: "返回列表",
    relatedArticles: "相关文章",
    publishedOn: "发布时间",
    category: "所属分类",
  },
  about: {
    title: "关于我们",
    brandIntro: "品牌介绍",
    reputation: "信誉与口碑",
    contact: "联系方式",
  },
};

export default common;